import { atomWithStorage } from '@capsicum/common';

export type V2MigrationTxHash = null | string;

export const v2MigrationTxHashAtom = atomWithStorage<V2MigrationTxHash>('v2MigrationTxHash', null);
